<app-transaction-result-view
[id]="id"
[shouldShowFlow]="true"
[title]="'Solicitud Nº ' + id"
[subtitle]="subtitle"
[messageBold]="messageBold"
[message]="message"
actionButtonText="Ver listado de solicitudes"
actionButtonPath="/license/approve"
secondaryButtonText="Crear una nueva solicitud"
secondaryButtonPath="/license/new"
[breadcrums]="breadcrums"
[variant]="variant"
></app-transaction-result-view>
